import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';
import {
  ProviderEntryDTO,
} from 'dtos';
import NPIInfo from 'pages/Dashboard/components/NPIInfo';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

type Props = {
  provider: ProviderEntryDTO;
  actions?: ReactNode;
  children?: ReactNode;
  classes?: Partial<Record<'root' | 'name' | 'details', string>>;
};

export default function ProviderCard({ provider, actions, children, classes }: Props) {
  const providerName = provider.type === 'NPI-2 Organization'
    ? provider.organizationName
    : getDisplayName(provider.formattedNames, DEFAULT_EMPTY_VALUE);

  return (
    <div className={clsx('flex w-full flex-col gap-2 rounded border border-gray-200 px-3 py-2', classes?.root)}>
      <div className="flex w-full items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5 text-left">
          <span className={clsx('min-w-0 max-w-full truncate text-sm font-semibold text-gray-900', classes?.name)}>
            {providerName}
          </span>
          <div className={clsx('flex min-w-0 flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500', classes?.details)}>
            <NPIInfo {...(provider.npi ?? {})} state={provider.state} />
          </div>
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}
